import type React from 'react';

import { token } from '@atlaskit/tokens';
import styled, { type StyledComponentClass } from 'styled-components';

type StyledComponentType<Props, Theme = any, ActualProps = Props> = StyledComponentClass<
	Props,
	Theme,
	ActualProps
>;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const ErrorContainer: StyledComponentType<
	React.ClassAttributes<HTMLDivElement> &
		React.HTMLAttributes<HTMLDivElement> & {
			isFullPage: boolean;
			imageMaxWidthPx?: string;
		},
	any,
	React.ClassAttributes<HTMLDivElement> &
		React.HTMLAttributes<HTMLDivElement> & {
			isFullPage: boolean;
			imageMaxWidthPx?: string;
		}
> = styled.div<{ isFullPage: boolean; imageMaxWidthPx?: string }>(
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) => ({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: props.isFullPage ? 'calc(100vh - 120px)' : undefined,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		minHeight: props.isFullPage ? '400px' : undefined,
		width: '100%',
		textAlign: 'center',
		img: {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			maxWidth: props.imageMaxWidthPx ?? '164px',
			width: '100%',
		},
		p: {
			margin: `${token('space.050')} 0`,
		},
	}),
);
